import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from'../Component/Header';  
import Footer from'../Component/Footer';  
import LazyLoad from "react-lazyload";  
const HealthSanitationCertificate = () => {  
  useEffect(() => {
    document.title = 'Health Sanitation Certificate - St. Francis Xavier School';  
}, []); 
    return (
        <>
        <Header/>
            <div className="innerslide">
                <ul className="breadcrumb">
                    <li><Link to="/"> Home</Link> </li>  
                    <li>CBSE Public Disclosure</li>
                    <li>Health Sanitation Certificate</li>
                </ul>
            </div> 
            <section className="innerbody">
               <div className="container"> 
                    <div className="row">
                    <div className="col-lg-12">
                    <div className="col-lg-12 mand_dis_sec">
      <iframe src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/pdf/WATER-HEALTH-AND-SANITATION--CERTIFICATE.pdf" width="100%" height="500" title="Transfer Certificate Sample" rel="noreferrer"></iframe>
                    <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/pdf/WATER-HEALTH-AND-SANITATION--CERTIFICATE.pdf" className="img-fluid mx-auto d-block" alt="sfxhisar"/></LazyLoad>
                    </div>
                    </div>
                    </div> 
                </div>
           </section>
           <Footer/>
        </>
    );
}

export default HealthSanitationCertificate;
